import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import Loader from 'react-loader-spinner'

import TextAreaComment from '../../atoms/textAreaComment/textAreaComment'
import CommentsSection from '../../atoms/commentsSection/commentsSection'

import ForumServices from '../../../services/forumServices'

import { competitionId } from '../../../constants/activity-constants'

import * as Utils from '../../../utils/utilsCampaign'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'

import './zonaVirtualContent.scss'

const ZonaVirtualContent = ({ isIos }) => {
  const isMobile = useMediaQuery()
  const session = new userSessionStorage()

  const [questions, setQuestions] = useState([])
  const [commentaries, setCommentaries] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [commentContent, setCommentContent] = useState('')

  const [buttonLoading, setButtonLoading] = useState(false)
  const [loadingThemes, setLoadingThemes] = useState(false)
  const [commetsLoading, setCommetsLoading] = useState(false)
  const [paginatorElements, setPaginatorElements] = useState([])
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(5)

  const getConfig = () => {
    let tokenId = session.getToken() ? session.getToken().idToken : null
    return {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
  }

  const postReply = async load => {
    setButtonLoading(true)
    const config = getConfig()
    try {
      ForumServices.saveForumReply(
        questions[activeIndex].forumId,
        commentContent,
        config
      ).then(resp => {
        setButtonLoading(false)
        setCommentContent('')
      })
    } catch (error) {
      setButtonLoading(false)
      console.log(error)
    }
    getComments(false)
  }

  const fillPaginatorButtons = number => {
    const auxiliarArray = []
    for (let i = 0; i < number; i++) {
      auxiliarArray.push(
        <button
          onClick={() => {
            setPage(i)
          }}
          className={`f-zonaVirtualInter-container__wrapper__content__paginator__button ${
            page === i && '--active'
          }`}
        />
      )
    }
    setPaginatorElements([auxiliarArray])
  }

  const getComments = async initial => {
    setCommetsLoading(true)
    // const config = getConfig()
    // se modifico el servicio para que sea opcional el logueo
    try {
      ForumServices.getRepliesByForum(
        initial ? parseInt(initial) : questions[activeIndex].forumId,
        page,
        size
        // config
      ).then(resp => {
        console.log(`comentaries zonaVirtualInterna --->`, resp)
        resp.data ? setCommentaries(resp.data) : setCommentaries([])
        resp.metadata
          ? fillPaginatorButtons(resp.metadata.limit)
          : fillPaginatorButtons(1)
        setCommetsLoading(false)
      })
    } catch (error) {
      setCommetsLoading(false)
    }
  }

  useEffect(() => {
    // const config = getConfig()
    setLoadingThemes(true)
    ForumServices.getForumByConcourseId(competitionId.tasks)
      .then(res => {
        setQuestions(res.data)
        setLoadingThemes(false)
        console.log('inter --> questions', questions)

        getComments(res.data[0].forumId)
      })
      .catch(e => console.log(e))
  }, [])

  useEffect(() => {
    getComments()
  }, [activeIndex, page])

  // const initialIndex = 1
  const initialIndex = () => {
    switch (process.env.LOCALE) {
      case 'es-EC':
        return 8
      case 'es-CL':
        return 14
      case 'es-DO':
        return 20
      default:
        return 26
    }
  }

  // useEffect(() => {
  //   getComments(initialIndex())
  // }, [])

  return (
    <div className={`f-zonaVirtualInter-container ${isIos ? 'propsIos' : ''}`}>
      <div className="f-zonaVirtualInter-container__wrapper">
        <span
          className="f-zonaVirtualInter-container__return"
          onClick={() => navigate('/')}
        >
          VOLVER
        </span>

        <div className="f-zonaVirtualInter-container__wrapper__description">
          <h1>Zona Virtual</h1>
          <p>
            {loadingThemes ? (
              <Loader
                type="TailSpin"
                color="#f01076"
                height={100}
                width={100}
              />
            ) : (
              questions &&
              questions[activeIndex ? activeIndex : 0] &&
              questions[activeIndex ? activeIndex : 0].question
            )}
          </p>
        </div>
        <div className="f-zonaVirtualInter-container__wrapper__content">
          <h2>Tema:</h2>
          <section className="f-zonaVirtualInter-container__wrapper__content__themes">
            <ul>
              {loadingThemes ? (
                <Loader
                  type="TailSpin"
                  color="#f01076"
                  height={100}
                  width={100}
                />
              ) : (
                questions &&
                questions.map((question, index) => {
                  return (
                    <li
                      className={index === activeIndex && 'active'}
                      key={index}
                      onClick={() => {
                        setPage(0)
                        setActiveIndex(index)
                        // setQuestionMobile(true)
                      }}
                    >
                      <h3>{question.title}</h3>
                    </li>
                  )
                })
              )}
            </ul>
          </section>
          <section className="f-zonaVirtualInter-container__wrapper__content__textAreaZona">
            <TextAreaComment
              colorError='white'
              max={500}
              setContent={setCommentContent}
              action={() => {
                if (commentContent.length > 0) {
                  postReply(true)
                }
              }}
              buttonLoading={buttonLoading}
            />
          </section>
          <section className="f-zonaVirtualInter-container__wrapper__content__commentZona">
            {commetsLoading ? (
              <div className="loader">
                <Loader
                  type="TailSpin"
                  color="#f01076"
                  height={150}
                  width={150}
                />
              </div>
            ) : (
              commentaries.map((comment, index) => {
                return (
                  <CommentsSection
                    key={index}
                    author={comment.userFullName}
                    date={Utils.formatDate(comment.replyDate)}
                    profilePhoto={comment.profilePhoto}
                    likesComment={comment.score}
                    // likesUser={comment.likeByUser}
                    comment={comment.comment}
                    idComment={comment.forumReplyId}
                    isMobile={isMobile}
                    config={getConfig()}
                    zonaVirtualInter={true}
                  />
                )
              })
            )}
          </section>
          <section className="f-zonaVirtualInter-container__wrapper__content__paginator">
            {paginatorElements.map(element => {
              return element
            })}
          </section>
          <section className="f-zonaVirtualInter-container__wrapper__content__buttonsPaginator">
            <button
              className="f-transparentButton"
              onClick={() => {
                if (activeIndex !== 0) {
                  setActiveIndex(activeIndex - 1)
                }
              }}
            >
              Anterior
            </button>
            <button
              className="f-transparentButton"
              onClick={() => {
                if (activeIndex !== questions.length - 1) {
                  setActiveIndex(activeIndex + 1)
                }
              }}
            >
              Siguiente
            </button>
          </section>
        </div>
      </div>
    </div>
  )
}

export default ZonaVirtualContent
